import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-print1',
  templateUrl: './print1.component.html',
  styleUrls: ['./print1.component.scss']
})
export class Print1Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
